export default __webpack_public_path__ + "static/media/woman-health-test.df755b67.svg";